import React, { createContext, useContext, useMemo } from 'react';

const AuthContext = createContext(null);
const AUTH_NOOP = async () => null;
const AUTH_BRIDGE_VALUE = {
  user: null,
  isAdmin: false,
  loading: false,
  authResolved: true,
  userProfileResolved: false,
  error: null,
  pendingEmailVerification: null,
  signInWithGoogle: AUTH_NOOP,
  signInWithGoogleRedirect: AUTH_NOOP,
  signUpWithEmail: AUTH_NOOP,
  signInWithEmail: AUTH_NOOP,
  resendEmailVerificationCode: AUTH_NOOP,
  verifyEmailSignUpCode: AUTH_NOOP,
  clearPendingEmailVerification: () => {},
  resetPassword: AUTH_NOOP,
  sendPhoneVerification: AUTH_NOOP,
  verifyPhoneCode: AUTH_NOOP,
  confirmationResult: null,
  logout: AUTH_NOOP,
  updateCredits: AUTH_NOOP,
  deductCredit: AUTH_NOOP,
  updateUserPlan: AUTH_NOOP,
  incrementProcessedCount: AUTH_NOOP,
  verifyRecaptcha: AUTH_NOOP,
  setError: () => {},
  globalCreditLock: false,
  creditPurchaseSyncNotice: null,
  dismissCreditPurchaseSyncNotice: () => {},
  purchaseExperience: null,
  dismissPurchaseExperience: () => {},
  legacyAuthWindowOpen: false,
  legacyAuthCutoffAtMs: 0,
  accountDeletionFlow: 'idle',
  reauthenticateForSensitiveAction: AUTH_NOOP,
  getRecentAuthAgeMs: async () => Number.POSITIVE_INFINITY,
  runAccountDeletionSchedule: AUTH_NOOP,
  cancelScheduledAccountDeletion: AUTH_NOOP,
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
};

export const AuthBridgeProvider = ({ children, value = null }) => {
  const bridgeValue = useMemo(
    () => ({ ...AUTH_BRIDGE_VALUE, ...(value || {}) }),
    [value],
  );

  return <AuthContext.Provider value={bridgeValue}>{children}</AuthContext.Provider>;
};

export { AuthContext };
